import { render, staticRenderFns } from "./BalanceGroupSelection.vue?vue&type=template&id=17059105&scoped=true"
import script from "./BalanceGroupSelection.vue?vue&type=script&lang=js"
export * from "./BalanceGroupSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17059105",
  null
  
)

export default component.exports